<template>
  <section id="services" class="services">

    <div class="container">

      <div class="section-header">

        <h2>

          {{ servicesTitle.first }}

          <span class="gradient-text">
            {{ servicesTitle.second }}
          </span>

        </h2>

        <p>
          {{ servicesTitle.description }}
        </p>

      </div>

      <div class="services-grid">

        <div
          v-for="service in services"
          :key="service.id"
          class="service-card"
        >

          <h3 class="gradient-text">
            {{ service.title }}
          </h3>

          <p>
            {{ service.description }}
          </p>

        </div>

      </div>

    </div>

  </section>
</template>

<script>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { services as servicesData } from "@/data/services"

export default {

  setup() {

    const { locale } = useI18n()

    const servicesTitle = computed(() => {
      return servicesData[locale.value]?.servicesTitle
    })

    const services = computed(() => {
      return servicesData[locale.value]?.services || []
    })

    return {
      servicesTitle,
      services
    }

  }

}
</script>

<style scoped>
.services {
  padding: 50px 20px;
  background: var(--bg-primario);
  scroll-margin-top: 90px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-family: 'Orbitron', sans-serif;
  font-size: clamp(24px, 4vw, 48px);
}

.section-header p {
  color: var(--cor-texto-suave);
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto 20px;
}

.services-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 30px;
}

.services-grid h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.services-grid p {
  font-size: 16px;
  color: var(--cor-texto-secundario);
  line-height: 1.5;
}

.service-card {
  width: 100%;
  max-width: 420px;
  background: var(--bg-destaque);
  border: 1px solid var(--card-base);
  border-radius: 20px;
  padding: 20px;
  transition: 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
  border-color: var(--card-destaque);
}

@media (max-width: 1280px) {

  .services-grid {
    gap: 20px;
    justify-content: center;
  }

  .service-card {
    max-width: 400px;
  }

  .services-grid h3 {
    font-size: 17px;
  }

  .services-grid p {
    font-size: 14px;
  }

}

@media (max-width: 800px) {

  .services {
    padding: 30px 20px;
  }

  .section-header {
    margin-bottom: 20px;
  }

  .section-header p {
    font-size: 12px;
    max-width: 400px;
  }

  .services-grid {
    gap: 10px;
    justify-content: center;
  }

  .services-grid h3 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .services-grid p {
    font-size: 12px;
  }

  .service-card {
    width: 100%;
    max-width: 400px;
    border-radius: 16px;
    padding: 10px;
  }

}
</style>